import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import { cellText } from "./columns";

// jsPDF's default font has no ₹ glyph — use "Rs." in PDFs.
const clean = (v) => String(v ?? "").replace(/₹/g, "Rs. ");
const RED = [210, 50, 71];

function header(doc, title, f) {
  const w = doc.internal.pageSize.getWidth();
  doc.setFillColor(...RED); doc.rect(0, 0, w, 22, "F");
  doc.setTextColor(255); doc.setFontSize(15); doc.text("Rescigo Health", 12, 10);
  doc.setFontSize(9); doc.text(title, 12, 17);
  doc.text(`${f.from} to ${f.to}`, w - 12, 10, { align: "right" });
  doc.text(`Generated ${new Date().toLocaleString("en-IN")}`, w - 12, 17, { align: "right" });
  doc.setTextColor(30);
  const used = [["Source", f.source], ["Category", f.category], ["SR status", f.sr_status], ["Payment", f.pay_state],
    ["Pay source", f.pay_source], ["Customer", f.q]].filter(([, v]) => v && v !== "all").map(([k, v]) => `${k}: ${v}`);
  doc.setFontSize(8); doc.text(`Filters: ${used.length ? used.join(" · ") : "none (all data)"}`, 12, 28);
  return 33;
}

const table = (doc, startY, title, columns, rows, foot) => {
  doc.setFontSize(11); doc.text(title, 12, startY);
  autoTable(doc, {
    startY: startY + 2, head: [columns.map(c => clean(c.label))],
    body: rows.map(r => columns.map(c => clean(cellText(c, r)))),
    foot: foot ? [columns.map(c => clean(cellText(c, foot)))] : undefined,
    styles: { fontSize: 7, cellPadding: 1.5 }, headStyles: { fillColor: [26, 26, 26] },
    footStyles: { fillColor: [247, 246, 242], textColor: 20 }, margin: { left: 12, right: 12 },
  });
  return doc.lastAutoTable.finalY + 8;
};

export function plainPdf({ title, columns, rows, foot, f }) {
  const doc = new jsPDF({ orientation: "landscape" });
  table(doc, header(doc, title, f), title, columns, rows, foot);
  doc.save(`${title.replace(/\s+/g, "-").toLowerCase()}_${f.from}_to_${f.to}.pdf`);
}

export async function brandedPdf({ f, cards, chartsEl, periodCols, periods, totals, leaderboards, ageing }) {
  const doc = new jsPDF({ orientation: "landscape" });
  const w = doc.internal.pageSize.getWidth();
  let y = header(doc, "Invoice Analytics — Management Report", f);
  const cw = (w - 24) / 6;
  cards.forEach((c, i) => {
    const x = 12 + (i % 6) * cw, yy = y + Math.floor(i / 6) * 18;
    doc.setDrawColor(229, 226, 217); doc.rect(x, yy, cw - 2, 16);
    doc.setFontSize(7); doc.setTextColor(120); doc.text(c.label.toUpperCase(), x + 2, yy + 5);
    doc.setFontSize(11); doc.setTextColor(20); doc.text(clean(c.value), x + 2, yy + 12);
  });
  y += Math.ceil(cards.length / 6) * 18 + 4;
  if (chartsEl) {
    const canvas = await html2canvas(chartsEl, { scale: 1.5, backgroundColor: "#ffffff" });
    const h = ((w - 24) * canvas.height) / canvas.width;
    if (y + h > 200) { doc.addPage(); y = 14; }
    doc.addImage(canvas.toDataURL("image/png"), "PNG", 12, y, w - 24, h);
    y += h + 6;
  }
  doc.addPage();
  y = table(doc, 14, "Period breakdown", periodCols, periods, { ...totals, period: "TOTAL" });
  const lb = [["sr_created", "Most SRs created", "sr_created"], ["paid", "Highest paid", "paid"], ["due", "Highest due", "due"]];
  lb.forEach(([k, t, field]) => {
    if (y > 170) { doc.addPage(); y = 14; }
    y = table(doc, y, `Top customers — ${t}`, [{ key: "name", label: "Customer" }, { key: "phone", label: "Phone" },
      { key: field, label: t, text: (r) => (["paid", "due"].includes(field) ? `Rs. ${r[field]}` : r[field]) }],
    (leaderboards?.[k] || []).slice(0, 10));
  });
  if (y > 170) { doc.addPage(); y = 14; }
  table(doc, y, "Dues ageing", [{ key: "bucket", label: "Age (days)" }, { key: "customers", label: "Customers" },
    { key: "amount", label: "Amount", text: (r) => `Rs. ${r.amount}` }], ageing || []);
  doc.save(`invoice-analytics-report_${f.from}_to_${f.to}.pdf`);
}
